import { render, staticRenderFns } from "./DailyExpenses.vue?vue&type=template&id=32b63bc5&"
import script from "./DailyExpenses.vue?vue&type=script&lang=js&"
export * from "./DailyExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports